<script lang="ts" setup>
// Explicit import required: the auto-import name for components/Buttons/
// is ButtonsInternalRedirectButton, so the bare tag resolves to nothing.
import InternalRedirectButton from "~/components/Buttons/InternalRedirectButton.vue";

usePageSeo('seoApproachTitle', 'seoApproachDescription');

const map = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d58622.21790708749!2d21.02581730818464!3d39.44786258219451!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135957a42e8c52e9%3A0xb157c4c26ac815a1!2zzp_Ooc6VzpnOks6RzqTOmc6azp8gzprOkc6kzpHOps6lzpPOmc6fIM6azpHOpM6RzqHOoc6RzprOpM6XIM6RzqHOpM6RzqM!5e0!3m2!1sen!2sat!4v1684515820643!5m2!1sen!2sat"

const fromKatarraktisWalk = "https://goo.gl/maps/ni2QW1vJGGNc23997";
const fromArta = "https://goo.gl/maps/pWGVP81s4gm4xE9Z6";
const fromIoannina = "https://goo.gl/maps/VmDTimPrFRdj3foW8";
const fromAthens = "https://goo.gl/maps/SWMjn5uMoDsUBdEG7";
</script>

<template>
  <div class="approach-page">
    <Hero
      :title="$t('howToGetHere')"
      :subtitle="$t('approachSubtitle')"
      backgroundImage="https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1684614479/refuge/outside/outside_19_gqhim7.jpg"
    />

    <div class="container">
      <section class="intro">
        <p class="lead">{{ $t('approach1') }}</p>
        <div class="details">
          <p>{{ $t('approach2') }}</p>
          <p>{{ $t('approach3') }}</p>
        </div>
      </section>

      <div class="content-grid">
        <!-- Transport Options -->
        <div class="transport-options">
          <div id="by-car" tabindex="-1" class="travel-method">
            <h3 class="method-title">{{ $t('byCar') }}</h3>
            <div class="links">
              <ApproachMapButton :redirectLink="fromArta" :destination="$t('fromArta')"/>
              <ApproachMapButton :redirectLink="fromAthens" :destination="$t('fromAthens')"/>
              <ApproachMapButton :redirectLink="fromIoannina" :destination="$t('fromIoannina')"/>
            </div>
          </div>

          <div id="by-bus" tabindex="-1" class="travel-method">
            <h3 class="method-title">{{ $t('byBus') }}</h3>
            <div class="links">
              <ApproachMapButton :destination="$t('ktelTzoumerka')" icon="none"
                                 redirectLink="https://www.dhmosktzoumerkwn.gr/epikoinonia/tilefonikos-katalogos/ktel.html"/>
            </div>
          </div>

          <div id="by-walking" tabindex="-1" class="travel-method">
            <h3 class="method-title">{{ $t('byWalking') }}</h3>
            <div class="links">
              <ApproachMapButton :redirectLink="fromKatarraktisWalk" :destination="$t('fromKatarraktis')"/>
            </div>
          </div>
        </div>

        <!-- Map -->
        <div class="map-view">
          <div class="map-frame">
            <iframe :src="map" :title="$t('approachMapTitle')" width="100%" height="100%"
                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"/>
          </div>
        </div>
      </div>

      <div class="footer-note">
        <InternalRedirectButton redirect="/activities/hiking-trails" :text="$t('hikingTrails')"/>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.approach-page
  width: 100%

.container
  max-width: 1200px
  margin: 0 auto
  padding: 0 2rem 6rem

.intro
  margin-bottom: 4rem
  max-width: 900px

  .lead
    font-size: 1.75rem
    font-weight: 700
    color: $color-primary
    margin-bottom: 1.5rem
    line-height: 1.3

  .details
    font-size: 1.2rem
    line-height: 1.7
    opacity: 0.8
    display: flex
    flex-direction: column
    gap: 1.25rem

.content-grid
  display: grid
  grid-template-columns: 1fr 1.5fr
  gap: 5rem
  margin-bottom: 4rem

.travel-method
  margin-bottom: 3rem
  &:last-child
    margin-bottom: 0

.method-title
  font-size: 1rem
  text-transform: uppercase
  letter-spacing: 1.5px
  font-weight: 800
  opacity: 0.5
  margin-bottom: 1.25rem

.links
  display: flex
  flex-direction: column
  gap: 0.75rem

.map-view
  height: 650px

.map-frame
  width: 100%
  height: 100%
  border-radius: 16px
  overflow: hidden
  border: 1px solid rgba(0, 0, 0, 0.1)
  box-shadow: $shadow-modern
  
  .dark-mode &
    border-color: rgba(255, 255, 255, 0.1)

  iframe
    border: none

.footer-note
  display: flex
  justify-content: center
  padding-top: 4rem
  border-top: 1px solid rgba(0, 0, 0, 0.05)

@media (max-width: 1024px)
  .content-grid
    grid-template-columns: 1fr
  
  .map-view
    height: 450px
    order: -1
</style>
